import React from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {TextBox} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {Skeleton} from '../../../../../../components/common/skeleton';

/*
 * Styles.
 */

const StyledLoadingTextFieldWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 9px;
  margin-bottom: 8px;
`;

const StyledTitleSkeleton = styled(Skeleton)`
  margin-top: 3px;
`;

/*
 * Helpers.
 */

export function maybeRenderConfigureDialogTextBox(
  value: string,
  label: React.ReactNode,
  onChange: HandlerOf<string>,
  options: {
    isDisabled?: boolean;
    isLoading?: boolean;
    isRequired?: boolean;
    isReadOnly?: boolean;
    placeholder?: string;
  },
) {
  if (options.isLoading) {
    return (
      <StyledLoadingTextFieldWrapperDiv>
        <StyledTitleSkeleton height="15px" width="100px" />
        <Skeleton height="30px" />
      </StyledLoadingTextFieldWrapperDiv>
    );
  }
  return (
    <TextBox
      value={value}
      onChange={onChange}
      label={label}
      isDisabled={options.isDisabled}
      isRequired={options.isRequired}
      isReadOnly={options.isReadOnly}
      placeholder={options.placeholder}
    />
  );
}
